<template>
    <div id="page">


        <img src="./../../../public/assets/hero-splash-2.jpeg" id="about">

        <br/><br/>

        <b-container class="mt-4 pt-4 text-block">

            <section>
                <h1 class="section--title">Chi siamo</h1>
                <p>
                  Agenzia viaggi by Vivamod è un servizio di prenotazione di viaggi e vacanze pensato per il welfare aziendale.
                  <br>
                  Grazie ad un percorso guidato sul nostro sito e grazie all’assistenza multicanale dei nostri consulenti di viaggio potrai prenotare vacanze complete di pernotto, volo, assicurazioni e altri servizi.
                  <br>
                  Ti offriamo un servizio di booking semplice e accessibile ma soprattutto viaggi sicuri e un servizio di assistenza attento e disponibile, senza eguali nel panorama del  booking online.
                </p>
            </section>

            <section>
                <Quote :text="'Il nostro staff di assistenza è contattabile tramite canali tradizionali come il telefono e l’email ma anche tramite canali innovativi come la webchat e il servizio di call back'" />
            </section>

          <!--<section>

            <b-row>
              <b-col sm="12" lg="7">
                <h4 class="text-center">La nostra mission</h4>

                <p>
                    La nostra mission è quella di realizzare soluzioni di travel booking fortemente orientate al cliente.
                    <br>
                    Sviluppo tecnologico e assistenza clienti generano sicurezza e tranquillità per gli utenti che viaggiano prenotando con {{site.brand}} ma anche per le aziende che affidano i loro dipendenti e i loro clienti ai nostri servizi.
                </p>

              </b-col>
              <b-col sm="12" lg="5">
                <RoundedImage
                  :image="require('./../../../public/assets/customer-care.jpg')"
                  :title="''"
                  :text="''"
                />
              </b-col>
            </b-row>

          </section>-->

          <!--<section>
              <p>Per farlo usiamo un attento mix di tecnologia e competenze umane:</p>
              <Checklist :items="checklistItems_mission" />
          </section>-->

          <div class="mt-4 mb-4 d-flex justify-content-center">
            <router-link :to="{name: 'homepage'}">
              <BtnBack text="Torna alla Home" />
            </router-link>
          </div>

        </b-container>

        <b-container class="text-block">

          <!--<section>

            <h1 id="come-funziona" class="text-center">Come funziona</h1>

            <NumberedItems :items="numberedItems_comeFunziona" />

            <br/>

            <h4 id="cosa-in-piu" class="text-center">Cosa ha di più {{site.brand}} rispetto ad un normale sito di prenotazioni?</h4>

            <div class="checklist">
                <ul>
                    <li>
                        <span class="checklist_icon" v-html="svg_semplicita_small"></span>
                        <span class="checklist_item">
                            <b>La semplicità di utilizzo del sito</b>
                            <br>
                            Il nostro sito è <b>integrato</b> con i principali portali di welfare aziendale e permette ai dipendenti delle aziende servite di utilizzare il loro credito welfare per prenotare viaggi in maniera semplice e sicura. L'utente che accede a {{site.brand}} dal portale welfare della sua azienda “trascina” il suo credito welfare e lo può utilizzare per pagare la sua prenotazione con un <b>addebito in tempo reale sul suo conto di welfare aziendale</b>
                        </span>
                    </li>
                    <li>
                        <span class="checklist_icon" v-html="svg_whitelist_small"></span>
                        <span class="checklist_item">
                            <b>L'attenta selezione delle strutture proposte</b>
                            <br>
                            {{site.brand}} seleziona in modo attento gli hotel e le altre strutture di ospitalità che ti proponiamo. Infatti delle oltre 500.000 strutture a cui abbiamo accesso ne proponiamo solo circa la metà. La chiamiamo <b>White List</b> perchè il meccanismo opera in modo preventivo bloccando il display delle nuove strutture disponibili finché queste non abbiano raggiunto un livello reputazionale sufficiente
                        </span>
                    </li>
                    <li>
                        <span class="checklist_icon" v-html="svg_double_check_small"></span>
                        <span class="checklist_item">
                            <b>La cura che poniamo ad ogni singola prenotazione</b>
                            <br>
                            Ogni prenotazione effettuata sul nostro sito, va incontro ad una procedura di <b>Double Check</b> ovvero una seconda verifica che avviene dopo la conferma della prenotazione verificando direttamente con la struttura, alcuni giorni prima del check-in, che non ci siano problemi e che tutto sia confermato come da prenotazione già confermata.
                        </span>
                    </li>
                </ul>
            </div>

            <br/>
            <br/>

            <b-row>
              <b-col sm="12" lg="7">
                <p>
                  {{site.brand}} si integra perfettamente con le meccaniche web di promozioni e concorsi B2B e B2C.
                  <br><br>
                  {{site.brand}} permette alle aziende di inserire i viaggi in soluzioni di loyalty realmente innovative perché garantiscono al cliente una online User Experience all'altezza degli standard attesi anche nello speciale e complesso ambito del travel.
                </p>
              </b-col>
              <b-col sm="12" lg="5">
                <RoundedImage
                  :image="require('./../../../public/assets/come-funziona.jpg')"
                  :title="''"
                  :text="''"
                />
              </b-col>
            </b-row>
          </section>-->

          <!--<div class="mt-4 mb-4 d-flex justify-content-center">
            <router-link :to="{name: 'homepage'}">
              <BtnBack text="Torna alla Home" />
            </router-link>
          </div>-->



          <!-- TODO -->
          <!--<section v-if="mixinUseTicketCompliments() && !mixinIsAuthenticated()">
            <h4 id="etc" class="text-center gold uppercase">Come prenotare usando i Ticket Compliments &reg;</h4>
            <p>
              Con {{site.brand}} è possibile <b>prenotare un soggiorno utilizzando i tuoi Ticket compliments &reg;</b>. Sarà necessario effettuare il login utilizzando le tue credenziali di accesso al tuo portale beneficiari o l’app Ticket Compliments &reg;. Clicca il seguente bottone per accedere al servizio.
            </p>
            <br><br>
            <p class="text-center">
              <a :href="this.$config.endpoints.etcSso" @click="trackEtcSso()">
                <svg_edenred_button_blue />
              </a>
            </p>
          </section>

          <div class="mt-4 mb-4 d-flex justify-content-center" v-if="mixinUseTicketCompliments() && !mixinIsAuthenticated()">
            <router-link :to="{name: 'homepage'}">
              <BtnBack text="Torna alla Home" />
            </router-link>
          </div>-->

          <section>
            <h1 class="section--title">Assistenza</h1>
            <p>
              Puoi contattarci per qualsiasi informazione e richiesta di supporto utilizzando uno dei canali indicati qui sotto.
            </p>
          </section>

        </b-container>


        <b-container fluid>
            <Prefooter />
        </b-container>

        <b-container>
            <div class="assistenza">
              <Quote :text="'Troverai sempre un’assistenza attenta, tempestiva, gentile e professionale.'" />
            </div>
        </b-container>


        <!--<b-container>

          <section>
            <Contacts />
          </section>


          <section class="text-center">
            <h2>{{site.brand}}: Soluzioni Business<br>per l’online travel booking</h2>
            <br>
            <p>
              La nostra società è leader in Italia nella fornitura di soluzioni business di online travel booking. Le nostre soluzioni vengono utilizzate da alcune tra le più innovative aziende italiane nel welfare aziendale, nel marketing, nei piani loyalty e nelle incentivazioni aziendali al trade.
            </p>
            <br>
            <b-row class="business-icons">
              <b-col sm="12" lg="4">
                <h4 class="icon-title">Loyalty</h4>
                <span v-html="svg_loyalty"></span>
              </b-col>
              <b-col sm="12" lg="4">
                <h4 class="icon-title">Marketing</h4>
                <span v-html="svg_marketing"></span>
              </b-col>
              <b-col sm="12" lg="4">
                <h4 class="icon-title">Welfare aziendale</h4>
                <span v-html="svg_welfare"></span>
              </b-col>
            </b-row>
          </section>

          <section>
            <p>
              Le nostre soluzioni dedicate ti permetteranno di integrare davvero il
              travel booking online all'interno di concorsi a premi, campagne
              promozionali, incentive al trade e piani loyalty.
            </p>
            <p>
              Con {{site.brand}} potrai davvero fornire ai tuoi clienti, partner e
              dipendenti la possibilità di prenotare viaggi all'interno delle tue
              campagne e soprattutto potrai farglielo fare online in totale sicurezza e
              semplicità <b>eliminando ogni soluzione di continuità</b> tra le tue
              piattaforme tecnologiche e il nostro servizio di travel booking per una
              <b>User Experience all'altezza degli standard attesi contemporanei</b>.
            </p>
            <p>
              Parlane con un nostro consulente, scrivi a <a :href="'mailto:'+site.emailBusiness">{{site.emailBusiness}}</a>
            </p>
          </section>


        </b-container>-->

        <div class="mt-4 mb-4 d-flex justify-content-center">
            <router-link :to="{name: 'homepage'}">
                <BtnBack text="Torna alla Home" />
            </router-link>
        </div>

    </div>
</template>

<script>

  import {
    svg_semplicita_small,
    svg_whitelist_small,
    svg_double_check_small,
    //svg_edenred_button_blue,
    svg_loyalty,
    svg_marketing,
    svg_welfare,
  } from '@/components/svg/static-pages'

  import Quote from '@/components/blocks/quote'
  import BtnBack from '@/components/atoms/btn-back'
  //import Checklist from '@/components/blocks/checklist'
  //import NumberedItems from '@/components/blocks/numbered-items'
  //import Contacts from '@/components/blocks/contacts'
  //import RoundedImage from '@/components/blocks/rounded-image'

  import Prefooter from '@/components/blocks/prefooter'

  export default {
    name: 'page',
    metaInfo: {
      title: 'informazioni',
    },
    components: {

      //Contacts,
      Quote,
      //Checklist,
      //RoundedImage,
      //NumberedItems,
      BtnBack,
      Prefooter

    },
    created(){
      this.svg_semplicita_small = svg_semplicita_small
      this.svg_whitelist_small = svg_whitelist_small
      this.svg_double_check_small = svg_double_check_small
      //this.svg_edenred_button_blue = svg_edenred_button_blue
      this.svg_loyalty = svg_loyalty
      this.svg_marketing = svg_marketing
      this.svg_welfare = svg_welfare
    },
    data() {
        return {
          site: this.$config.site,
          checklistItems_mission : {
            0: "Il continuo sforzo di sviluppo tecnologico degli algoritmi che\n" +
              "selezionano i migliori tra gli oltre 500.000 hotel disponibili a cui\n" +
              "accediamo a livello italiano e internazionale, come anche lo sviluppo\n" +
              "di innovativi meccanismi di double check delle prenotazioni, non\n" +
              "sarebbero nulla senza la gentilezza, la competenza e la disponibilità\n" +
              "del nostro staff di customer care",
            1: "L'incessante lavoro di miglioramento\n" +
              "della user experience del nostro sito web non sarebbe nulla senza la\n" +
              "profonda comprensione, da parte del nostro management, dell'universo\n" +
              "travel nelle sue incessanti evoluzioni e cambiamenti",
          },
          numberedItems_comeFunziona : {
            0: {
                title: "DEVI ACCEDERE PASSANDO DAL PORTALE WELFARE",
                content: "<b>per utilizzare il servizio occorre accedere a " + this.$config.site.brand + " partendo dal link dentro al proprio portale welfare.</b><br>Se sei arrivato su questo sito da Google o digitando l’indirizzo " + this.$config.site.host + " sul browser stai visualizzando una versione che non permette di fare ricerche e prenotazioni."
              },
            1: {
                title: "COME PAGARE LA PRENOTAZIONE",
                content: "il <b>pagamento della prenotazione</b> è la cosa più semplice del mondo perchè viene fatto tramite <b>addebito diretto e automatico sul tuo credito welfare.</b> Non è possibile pagare con carta di credito."
              },
          },
        }
    },
    mounted() {

    },
    methods:{

    }
  }
</script>

<style lang="scss">
#page
{
    .checklist_icon
    {
        width:45px;
        margin-right: 1rem;
        display: flex;
        align-items:flex-start;
        justify-content:flex-start;
        svg
        {
            min-width: 100%;
            height:auto;
        }
    }

    .prefooter-blocks-small
    {
      margin-top:2rem;
    }

    .quote
    {
      margin:auto;
      margin-top:6rem;
      margin-bottom:4rem;
      max-width: 660px;
    }

    .text-block
    {
      text-align:center;
      margin-bottom:4rem;
    }
}
</style>